module.exports = "query NegativeExperience {\n  negativeExperience {\n    id\n    title\n    status\n  }\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/queries/NegativeExperience.graphql
// module id = 1997
// module chunks = 1612